import { Link, useLocation } from "react-router-dom";
import { ThemeToggle } from "./ThemeToggle";
import { MusicPlayer } from "./MusicPlayer";
import { CartDrawer } from "./CartDrawer";
import { cn } from "@/lib/utils";
import { useTransparentLogo } from "@/hooks/use-transparent-logo";
import logoImg from "@/assets/adeles-art-logo.webp";

const links = [
  { to: "/", label: "Home" },
  { to: "/gallery", label: "Gallery" },
  { to: "/for-sale", label: "For Sale" },
];

// Admin route is intentionally obscured as /zombieburger

export function Navbar() {
  const { pathname } = useLocation();
  const transparentLogo = useTransparentLogo(logoImg);

  return (
    <nav className="sticky top-0 z-50 flex items-center justify-between px-6 py-3 backdrop-blur-md bg-background/80 border-b border-border">
      <Link to="/">
        <img src={transparentLogo ?? logoImg} alt="Adele's Art" className="h-10" width={56} height={40} />
      </Link>

      <div className="flex items-center gap-1 sm:gap-4">
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className={cn(
              "font-fredoka text-sm sm:text-base font-medium px-3 py-1 rounded-full transition-colors",
              pathname === l.to
                ? "bg-primary text-primary-foreground"
                : "hover:bg-muted text-foreground"
            )}
          >
            {l.label}
          </Link>
        ))}
        <CartDrawer />
        <MusicPlayer />
        <ThemeToggle />
      </div>
    </nav>
  );
}
